<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Nuevo Comercio&nbsp
              |
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
        .columns
          .column.is-12
            FormComercio(:comercio="comercioSel" @saveForm="saveForm")
        .columns.column-blanco
</template>

<script>
  import NavBar from '../layout/NavBarTransportes.vue'
  import FormComercio from './FormComercio.vue'
  import Loader from '@/components/shared/Loader.vue'
  import usuariosServices from '@/services/usuarios/usuarios'
  import InventarioServices from '@/services/inventario/inventario'
  
  export default {
    name: 'NewTraspaso',
    components: { NavBar, Loader, FormComercio },
    data() {
      return {
        isLoading: true,
        comercioSel: {},
      }
    },
    methods: {
      iniciarComponente () {
        this.isLoading = false
      },
      
      saveForm(f) {
        
        InventarioServices.addTarjeta_Comercio(f.nombre)
          .then( (data) => {
            console.log(data)
            this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done':'ban', 'OK')
            this.isLoading = false
            this.$router.push('/Transportes/Tarjetas/Comercios')
          })
          .catch( (e) => {
            this.isLoading = false
            this.displayToast('bubble',e.message, 'ban', 'OK')
          })
      },
      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backToPage () {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/comercios/NuevoComercio.vue